/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Event_Group_Not_FoundInputs */

const en_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected event group not found`)
};

const fr_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements selectionne introuvable`)
};

const de_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisgruppe nicht gefunden`)
};

const it_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi selezionato non trovato`)
};

const ru_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранная группа событий не найдена`)
};

const es_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró el grupo de eventos seleccionado`)
};

const zh_cn2_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到所选事件组`)
};

const ja_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントグループが見つかりません`)
};

const hi_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह नहीं मिला`)
};

const pt_pt2_embed_captions_event_group_not_found = /** @type {(inputs: Embed_Captions_Event_Group_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos selecionado não encontrado`)
};

/**
* | output |
* | --- |
* | "Selected event group not found" |
*
* @param {Embed_Captions_Event_Group_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_event_group_not_found = /** @type {((inputs?: Embed_Captions_Event_Group_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Event_Group_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_event_group_not_found(inputs)
	if (locale === "de") return de_embed_captions_event_group_not_found(inputs)
	if (locale === "it") return it_embed_captions_event_group_not_found(inputs)
	if (locale === "ru") return ru_embed_captions_event_group_not_found(inputs)
	if (locale === "es") return es_embed_captions_event_group_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_event_group_not_found(inputs)
	if (locale === "ja") return ja_embed_captions_event_group_not_found(inputs)
	if (locale === "hi") return hi_embed_captions_event_group_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_event_group_not_found(inputs)
	return en_embed_captions_event_group_not_found(inputs)
});